
import { defineComponent, SetupContext, reactive } from "vue";

interface State {
  barSide: string;
}

// Component definition
export default defineComponent({
  name: "TurnPageButton",
  props: {
    isShowAlways: Boolean,
    direction: {
      type: String,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const state = reactive<State>({
      barSide: props.direction === "prev" ? "left" : "right"
    });

    const movePage = (direction: number) => {
      // if no change, return
      if (!direction) return;
      // move page
      context.emit("move-page", direction);
    };

    return {
      movePage,
      props,
      state
    };
  }
});
